import { stoageGetter } from "../helpers";
import { UploadDocumentsConstants } from "../components/UploadDocument/UploadDocumentsUtility";

const USER = stoageGetter("user");
const channelCode = USER?.channelCode?.channelCode;
const GIFT_CITY_CHANNEL_CODE = "CH103";

export const isGiftCityChannel = () => {
  const isGiftChannel = channelCode === GIFT_CITY_CHANNEL_CODE ? true : false;
  return isGiftChannel;
};

//extract route from url and slice it
export const extractRoute = (url) => {
  const urlParts = url.split("/");
  const route = "/" + urlParts.slice(3).join("/");
  return route;
};

export const routeAsPerProposalStatus = (item) => {
  const proposalStatus = item?.proposalStatus;
  // console.log("proposalStatus", item?.currentLocationURL);
  switch (proposalStatus) {
    case "Login WIP - Proposal Draft":
    // console.log("inside draft");
      return checkOldRoute(item?.currentLocationURL ? item?.currentLocationURL : 
        (item?.regenerateBi === true || item?.isBIStageCompleted === false) ? "currentLocationURL" : 
      (item?.leadId?.leadDisposition === "Login WIP - Document Upload Pending") 
      ? "Login WIP - Document Upload Pending" : "/kyc-details");
      
    case "Login WIP - OTP Authentication pending":
    case "Pending OTP":
    case "OTP Authentication Pending":
      return "/otpauthentication";
    case "Login WIP - Payment Pending":
    case "Payment Pending":
      return "/payments";
    case "Login WIP - Mandate Pending":
    case "Mandate Pending":
      return "/payments";
    case "Login WIP - e-SIR Pending":
    case "e-SIR Pending":
      return "/esir";
    case "Login WIP - Document Upload Pending":
    case "Document Upload Pending":
      // Use currentLocationURL for document upload routes
      return item?.currentLocationURL || checkOldRoute(item?.currentLocationURL);
    case "Login WIP - Proposal Form Filling Pending":
    case "Proposal Form Filling Pending":
      // Use currentLocationURL for proposal form filling routes
      return item?.currentLocationURL || "/proposalFormFilling/aboutCustomer";
    case "Login WIP - Dynamic Document Upload Pending":
    case "Dynamic Document Upload Pending":
      // Use currentLocationURL for dynamic document upload routes
      return item?.currentLocationURL || "/uploaddynamicdoc/proposer";
    case "Login WIP - Benefit Illustrator Pending":
    case "Benefit Illustrator Pending":
      // Use currentLocationURL for benefit illustrator routes
      return item?.currentLocationURL || "currentLocationURL";
    case "RTS Submitted":
    case "RTS Pending":
      return `/rts-details/${item?.policyId}`;
    case "Login successful - Login Successful":
      return "/finalSubmit";
    default:
      return "currentLocationURL";
  }
};

export const checkOldRoute = (route) => {
  // console.log("route", route);
  switch (route) {
    case "/uploaddoc/addressProof":
      return UploadDocumentsConstants.PHOTOGRAPH_LI.route;
    case "/uploaddoc/photoIdProof":
      return UploadDocumentsConstants.PHOTOGRAPH_PROPOSER.route;
    case "/uploaddoc/incomeProof":
      return UploadDocumentsConstants.PHOTO_ID_LI.route;
    case "/uploaddoc/proposerphotoidproof":
      return UploadDocumentsConstants.PHOTO_ID_PROPOSER.route;
    case "/uploaddoc/ageProof":
      return UploadDocumentsConstants.ADDRESS_PROOF_LI.route;
    case "/uploaddoc/proposerphotoaddressproof":
      return UploadDocumentsConstants.ADDRESS_PROOF_PROPOSER.route;
    case "/uploaddoc/piocardlifeInsured":
      return UploadDocumentsConstants.PIO_CARD_LI.route;
    case "/uploaddoc/proposerpiocard":
      return UploadDocumentsConstants.PIO_CARD_PROPOSER.route;
    case "/uploaddoc/passportcardlifeInsured":
      return UploadDocumentsConstants.PASSPORT_LI.route;
    case "/uploaddoc/passportcardpropoer":
      return UploadDocumentsConstants.PASSPORT_PROPOSER.route;
    case "/kyc-details":
       return "/kyc-details";
    case "Login WIP - Document Upload Pending":
      return UploadDocumentsConstants.PHOTOGRAPH_LI.route;
    default:
      return "currentLocationURL";
  }
};
